import { CircularProgress } from '@mui/material';
import { lazy, Suspense } from 'react';
import { createBrowserRouter } from 'react-router-dom';
import { AuthenticatedGuard } from './Components/AuthenticatedGuard';
import { PageRoot } from './Components/PageRoot';

const HomePage = lazy(() => import('./Components/Pages/Home/HomePage'));
const BatchPage = lazy(() => import('./Components/Pages/Batch/BatchPage'));
const SelectSingleProductPage = lazy(() => import('./Components/Pages/SelectSingleProduct/SelectSingleProductPage'));
const SelectSwapPage = lazy(() => import('./Components/Pages/SelectSwap/SelectSwapPage'));
const BatchRequestPage = lazy(() => import('./Components/Pages/Batch/BatchRequest.page'));
const BatchListPage = lazy(() => import('./Components/Pages/BatchList/BatchList.page'));
const NotFound404 = lazy(() => import('./Components/Pages/404'));

export const router = createBrowserRouter(
  [
    {
      path: '/',
      element: <PageRoot />,
      children: [
        { path: '/healthcheck', element: <div>OK</div> },
        {
          path: '/',
          element: <AuthenticatedGuard />,
          children: [
            { path: '/', element: PageLoader(HomePage) },
            { path: '/products', element: PageLoader(SelectSingleProductPage) },
            { path: '/swaps/:productId', element: PageLoader(SelectSwapPage) },
            {
              path: '/batch',
              children: [
                { index: true, element: PageLoader(BatchPage) },
                { path: ':batchRequestId', element: PageLoader(BatchRequestPage) },
                { path: 'list', element: PageLoader(BatchListPage) },
              ],
            },
          ],
        },
        { path: '*', element: PageLoader(NotFound404) },
      ],
    },
  ],
  { basename: process.env.NODE_ENV === 'uat' ? '/dev2' : '' },
);

function PageLoader(Page: ReturnType<typeof lazy>) {
  return (
    <Suspense fallback={<BasicLoadingTemplate />}>
      <Page />
    </Suspense>
  );
}

export function BasicLoadingTemplate() {
  return <CircularProgress disableShrink sx={{ m: 'auto' }} />;
}
